import styled from 'styled-components';
var FormContainer = styled.div.withConfig({
  displayName: "FormContainer",
  componentId: "sc-1gwq5oj-0"
})(["clear:both;"]);
export default FormContainer;